<template>
  <Button
    zoom
    secondary
    :label="label"
    labelInner
    :disabled="disabled"
    :handleClick="handleClick"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'ZoomButton',

  components: { Button },

  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handleClick: Function
  }
})
</script>
